import { Dialog, DialogBackdrop, Transition, TransitionChild } from '@headlessui/react'
import clsx from 'clsx'
import { useRef } from 'react'

type DrawerProps = {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  side?: 'left' | 'right' // New prop to specify the side
  [key: string]: any
}

const Drawer = ({ open, onClose, children, side = 'right', ...rest }: DrawerProps) => {
  const ref = useRef<HTMLDivElement>()

  return (
    <Transition<'div'> show={open} className='transition duration-300 ease-in data-[closed]:opacity-0'>
      <Dialog as='div' style={{ zIndex: 100 }} className='fixed inset-0 overflow-hidden' onClose={onClose}>
        <div className='absolute inset-0 grid overflow-hidden'>
          <DialogBackdrop className='absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity' onClick={onClose} />
          <div
            className={clsx(`fixed inset-y-0 flex max-w-full`, side === 'right' ? 'right-0 pl-2' : 'left-0 pr-2')}
            ref={ref as any}
          >
            <TransitionChild<'div'>
              className={clsx(
                `translate-x-0 transform transition duration-300 ease-in-out`,
                side === 'right' ? 'data-[closed]:translate-x-full' : 'data-[closed]:-translate-x-full',
              )}
            >
              <div className='w-screen max-w-md' {...rest}>
                <div className='flex h-full flex-col overflow-y-auto bg-white shadow-xl'>
                  <div className='relative flex-1'>
                    <div className='absolute inset-0 flex flex-col'>{children}</div>
                  </div>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Drawer
